import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'stockMutationsHandedOff',
      'stockDecommissioned',
    ]),

    bridgeStockWriteBlocked() {
      return this.stockMutationsHandedOff || this.stockDecommissioned;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/mixins/bridgeHandoff.js